import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "cover" }, null, -1)
const _hoisted_2 = { class: "layout-summary" }


import { NCard } from "naive-ui";
import { useRouter } from 'vue-router'

type set = {
  ID: string;
  Articletype: string;
  ApplicationCode: string;
  CategoryCode: string;
  SortIndex: string;
  GroupIndex: string;
  Title: string;
  TitleClass: string;
  Summary: string;
  Author: string;
  Keyword: string;
  HomeImagePath: string;
  PublishDate: string;
  OutLink: string;
  AccessoryLink: string;
  AccessoryTitle: string;
};


export default /*#__PURE__*/_defineComponent({
  props: ['data'],
  setup(__props) {

const props = __props

let router = useRouter();
const style = {
  header: { color: "#ffc445FF" },
  content: { color: "black" },
};



const onClick = function () {
  if (props.data.OutLink) {
    window.open(props.data.OutLink)
  } else {
    let link = "./Article?ArticleID=" + props.data.ID

    window.open(router.resolve({
      name: 'Article',
      query: { ArticleID: props.data.ID }
    }).href);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "component-set-item",
    onClick: onClick
  }, [
    _createVNode(_unref(NCard), {
      title: props.data.Title,
      bordered: false,
      "content-style": style.content,
      "header-style": style.header
    }, {
      cover: _withCtx(() => [
        _createElementVNode("div", {
          class: "cover",
          style: _normalizeStyle({ backgroundImage: `url(${props.data.HomeImagePath})` })
        }, null, 4)
      ]),
      default: _withCtx(() => [
        _hoisted_1,
        _createElementVNode("div", _hoisted_2, _toDisplayString(props.data.Summary), 1)
      ]),
      _: 1
    }, 8, ["title", "content-style", "header-style"])
  ]))
}
}

})